/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import { AiFillEye } from "react-icons/ai";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import { AppWrap } from "../../wrapper";
import MotionWrap from "../../wrapper/MotionWrap";
import "./Work.scss";

import {
  agileProjectManagementProject,
  codamProject,
  hanUniversityProject,
  idealProject,
  infoEmergingIndustriesProject,
  lloydsEchoProject,
  takeawayProject,
  codamProjectV2,
  babbelProject,
  unknownUniProject,
  chapterProject,
  kfcProject,
} from "../../constants/projects";

type Work = {
  name: string;
  description: string;
  imgUrl: string;
  projectLink: string;
  codeLink: string;
  title: string;
  tags: string[];
  company?: string;
};

const newProjects: Work[] = [
  {
    name: agileProjectManagementProject.title,
    description: agileProjectManagementProject.description,
    codeLink: "#",
    imgUrl: agileProjectManagementProject.image.value as string,
    projectLink: "/project/agile",
    tags: ["Concept"],
    title: agileProjectManagementProject.title,
    company: "Info Business Innovation Partner",
  },
  {
    name: codamProject.title,
    description: codamProject.description,
    codeLink: "#",
    imgUrl: codamProject.image.value as string,
    projectLink: "/project/codam-mentoring",
    tags: ["Mentoring"],
    title: codamProject.title,
    company: "Codam Coding University",
  },
  {
    name: hanUniversityProject.title,
    description: hanUniversityProject.description,
    codeLink: "#",
    imgUrl: hanUniversityProject.image.value as string,
    projectLink: "/project/han",
    tags: ["Engineering"],
    title: hanUniversityProject.title,
    company: "HAN Open Science",
  },
  {
    name: idealProject.title,
    description: idealProject.description,
    codeLink: "#",
    imgUrl: idealProject.image.value as string,
    projectLink: "/project/ideal",
    tags: ["Engineering"],
    title: idealProject.title,
    company: "Nationale Nederlanden",
  },
  {
    name: infoEmergingIndustriesProject.title,
    description: infoEmergingIndustriesProject.description,
    codeLink: "#",
    imgUrl: infoEmergingIndustriesProject.image.value as string,
    projectLink: "/project/emerging-industries",
    tags: ["Concept"],
    title: infoEmergingIndustriesProject.title,
    company: "Infor Business Innovation Partner",
  },
  {
    name: lloydsEchoProject.title,
    description: lloydsEchoProject.description,
    codeLink: "#",
    imgUrl: lloydsEchoProject.image.value as string,
    projectLink: "/project/lloyds",
    tags: ["Engineering"],
    title: lloydsEchoProject.title,
    company: "Lloyds Banking Group",
  },
  {
    name: takeawayProject.title,
    description: takeawayProject.description,
    codeLink: "#",
    imgUrl: takeawayProject.image.value as string,
    projectLink: "/project/thuisbezorgd",
    tags: ["Engineering"],
    title: takeawayProject.title,
    company: "Thuisbezorgd",
  },
  {
    name: codamProjectV2.title,
    description: codamProjectV2.description,
    codeLink: "#",
    imgUrl: codamProjectV2.image.value as string,
    projectLink: "/project/codam-professional-development",
    tags: ["Mentoring"],
    title: codamProjectV2.title,
    company: "Codam Coding University",
  },
  {
    name: babbelProject.title,
    description: babbelProject.description,
    codeLink: "#",
    imgUrl: babbelProject.image.value as string,
    projectLink: "/project/babbel",
    tags: ["Engineering"],
    title: babbelProject.title,
    company: "Babbel",
  },
  // {
  //   name: unknownUniProject.title,
  //   description: unknownUniProject.description,
  //   codeLink: "#",
  //   imgUrl: unknownUniProject.image.value as string,
  //   projectLink: "/project/unknown-university",
  //   tags: ["Mentoring"],
  //   title: unknownUniProject.title,
  //   company: "Unknown University Of Applied Sciences",
  // },
  {
    name: "AI Chatbot",
    description:
      "Streaming tutorial data via an AI chatbot assistant for hardware installers.",
    codeLink: "#",
    imgUrl: chapterProject.image.value as string,
    projectLink: "/project/chapter-works",
    tags: ["Engineering"],
    title: chapterProject.title,
    company: "ChapterWorks",
  },
  {
    name: kfcProject.title,
    description: kfcProject.description,
    codeLink: "#",
    imgUrl: kfcProject.image.value as string,
    projectLink: "/project/kfc",
    tags: ["Engineering"],
    title: "KFC Menu Generation",
    company: "KFC",
  },
].sort((a, b) => a.title.localeCompare(b.title));

const WorkComponent = () => {
  const [works, setWorks] = useState<Work[]>([]);
  const [filterWork, setFilterWork] = useState<Work[]>([]);
  const [activeFilter, setActiveFilter] = useState<string>("All");
  const [animateCard, setAnimateCard] = useState<{
    y: number;
    opacity: number;
  }>({
    y: 0,
    opacity: 1,
  });
  const navigation = useNavigate();

  useEffect(() => {
    setWorks(newProjects);
    setFilterWork(newProjects);
  }, []);

  const handleWorkFilter = (item: string) => {
    setActiveFilter(item);
    setAnimateCard({ y: 100, opacity: 0 });

    setTimeout(() => {
      setAnimateCard({ y: 0, opacity: 1 });
      if (item === "All") {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  return (
    <>
      <h2 className="head-text">
        Featured <span>Projects</span>
      </h2>

      <div className="app__work-filter">
        {["Concept", "Engineering", "Mentoring", "All"].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__work-portfolio"
      >
        {filterWork.map((work, index) => (
          <div
            className="app__work-item app__flex"
            key={index}
            onClick={() => navigation(work.projectLink)}
          >
            <div className="app__work-img app__flex">
              <img src={work.imgUrl} alt={work.name} />

              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.25,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="app__work-hover app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="">{work.title}</h4>
              <p
                className="work-p-text"
                style={{ marginTop: 10, textAlign: "center" }}
              >
                {work.description}
              </p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}
      </motion.div>
    </>
  );
};

export default AppWrap(
  MotionWrap(WorkComponent, "app__works"),
  "work",
  "app__primarybg",
);
